/** @typedef {'draft'|'submitted'|'approved'|'ordered'|'received'} WorkflowStatus */

export const WORKFLOW = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
  APPROVED: "approved",
  ORDERED: "ordered",
  RECEIVED: "received",
};

const ORDER = [WORKFLOW.DRAFT, WORKFLOW.SUBMITTED, WORKFLOW.APPROVED, WORKFLOW.ORDERED, WORKFLOW.RECEIVED];

/**
 * Infer workflow from Firestore doc (legacy docs have no workflowStatus).
 * @param {Record<string, unknown>} po
 * @returns {WorkflowStatus}
 */
export function getWorkflowStatus(po) {
  const ws = String(po?.workflowStatus || "").toLowerCase();
  if (ORDER.includes(ws)) return /** @type {WorkflowStatus} */ (ws);

  const st = String(po?.status || "").toLowerCase();
  if (st.includes("cancel")) return WORKFLOW.DRAFT;
  const received = po?.orderReceived === true || po?.received === true || st.includes("received");
  if (received) return WORKFLOW.RECEIVED;
  return WORKFLOW.SUBMITTED;
}

/** @param {WorkflowStatus} from */
export function allowedNextStatuses(from) {
  switch (from) {
    case WORKFLOW.DRAFT:
      return [WORKFLOW.SUBMITTED];
    case WORKFLOW.SUBMITTED:
      return [WORKFLOW.APPROVED, WORKFLOW.RECEIVED];
    case WORKFLOW.APPROVED:
      return [WORKFLOW.ORDERED, WORKFLOW.RECEIVED];
    case WORKFLOW.ORDERED:
      return [WORKFLOW.RECEIVED];
    default:
      return [];
  }
}

/**
 * @param {WorkflowStatus} from
 * @param {WorkflowStatus} to
 */
export function isAllowedTransition(from, to) {
  return allowedNextStatuses(from).includes(to);
}

/** SLA band for display: 'ok' | 'warn' | 'critical' */
export function slaBand(days) {
  const d = Number(days) || 0;
  if (d < 7) return "ok";
  if (d <= 14) return "warn";
  return "critical";
}

export function slaBandClass(band) {
  if (band === "ok") return "bg-emerald-50 text-emerald-900 border-emerald-200";
  if (band === "warn") return "bg-amber-50 text-amber-900 border-amber-200";
  return "bg-rose-50 text-rose-900 border-rose-200";
}
